import { render, staticRenderFns } from "./forms-history-screen.vue?vue&type=template&id=c3d23232&scoped=true&"
import script from "./forms-history-screen.vue?vue&type=script&lang=js&"
export * from "./forms-history-screen.vue?vue&type=script&lang=js&"
import style0 from "./forms-history-screen.vue?vue&type=style&index=0&id=c3d23232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d23232",
  null
  
)

export default component.exports